import { MicOff, X } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface Props {
  visible: boolean;
  onDismiss: () => void;
  onPause?: () => void;
  onStop: () => void;
}
export const RecordingSilenceAlert = ({ visible, onDismiss, onPause, onStop }: Props) => {
  const { t, language } = useLanguage();
  if (!visible) return null;
  return (
    <Alert variant="destructive" role="status" dir={language === 'he' ? 'rtl' : 'ltr'}>
      <Button type="button" variant="ghost" size="icon" onClick={onDismiss}
        aria-label={t('recordingSilence.dismiss')} className="absolute end-1 top-1 size-7">
        <X aria-hidden className="size-4" />
      </Button>
      <MicOff aria-hidden />
      <AlertTitle className="pe-7">{t('recordingSilence.title')}</AlertTitle>
      <AlertDescription>
        <p>{t('recordingSilence.message')}</p>
        <div className="flex flex-wrap gap-2" dir="ltr">
          {onPause && <Button type="button" size="sm" variant="outline" onClick={onPause}>
            {t('recordingSilence.pause')}
          </Button>}
          <Button type="button" size="sm" onClick={onStop}>{t('recordingSilence.finish')}</Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};
